module.exports = __webpack_public_path__ + "img/icon-sb-call-blue-color-48-v2.6340064.svg";